<template>
  <div class="meta-block">
    <h4 class="meta-subtitle">Item Metadata</h4>
    <KeyValueList :items="items" />
  </div>
</template>

<script>
/**
 * Left-panel "Item Metadata" block.
 *
 * Purely presentational — takes a preformatted `items` array from the
 * VERIFICATION/GET_METADATA_ITEMS getter, renders via KeyValueList.
 *
 * Wireframe reference: AVA Verification Wireframe.html §Item Metadata block
 * (lines 599-609), meta-block styles (lines 98-100).
 */
import KeyValueList from '@/features/Verification/components/shared/KeyValueList.vue';

export default {
  name: 'ItemMetadata',
  components: { KeyValueList },
  props: {
    items: {
      type: Array,
      required: true,
      // Expected item shape: { k: String, v: String, mono?: Boolean }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../styles/verification-tokens';

.meta-block {
  padding: 14px 0;
  border-bottom: 1px dashed $vf-line-soft;
}

// `.meta-subtitle` instead of bare h4 selector — H4 itself is fine in
// Vuetify 2, but the naming is consistent with how StatusChip etc. avoid
// collision surface area.
.meta-subtitle {
  font-size: 11px;
  font-family: $vf-font-mono;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: $vf-ink-3;
  font-weight: 500;
  margin: 0 0 10px 0;
}
</style>
